module.exports = __webpack_public_path__ + "static/media/Mix_inicio_telf.ac7d465f.png";